const getSegmentServices = (services, origin, destination) =>
  services.filter(
    ({ segment }) => !!segment && segment.origin === origin && segment.destination === destination,
  );

export default getSegmentServices;
